// extracted by mini-css-extract-plugin
export var buttonContainer = "styles-module__buttonContainer___STn69";
export var previewsContainer = "styles-module__previewsContainer___aMJNs";
export var shadowOnScroll = "styles-module__shadowOnScroll___AhygL";
export var thumbnailsContainer = "styles-module__thumbnailsContainer___D7KE2";